import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CadViewerCanvasComponent } from '../cad-viewer-canvas/cad-viewer-canvas.component';
import { CadDrawing } from 'src/app/shared/services/cad-viewer.service';

export interface CadViewerDialogData {
  drawing: CadDrawing;
  /** Authenticated download of the original; without it the header links to `drawing.file_url`. */
  onDownload?: () => void;
}

@Component({
  selector: 'app-cad-viewer-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, CadViewerCanvasComponent],
  templateUrl: './cad-viewer-dialog.component.html',
  styleUrls: ['./cad-viewer-dialog.component.css'],
})
export class CadViewerDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CadViewerDialogData,
    private dialogRef: MatDialogRef<CadViewerDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
